export { UpdateDogMedicalInfo as UpdateDogMedicalInfoV2 } from './UpdateDogMedicalInfo'
